<template>
    <div>
        <DataTable :value="deals" dataKey="token">
            <Column header="Токен" field="token" ></Column>
            <Column header="Направление" field="direction" ></Column>
            <Column header="Покупка" >
                <template #body="slotProps">
                    {{short_timezoned(slotProps.data.started_at)}}
                </template>
            </Column>
            <Column header="Причина" field="start_reason" ></Column>
            <Column header="Курс" field="rate_started" ></Column>
            <Column header="%">
                <template #body="slotProps">
                    {{round(calculatePercentProfit(slotProps.data, currentPrice), 4)}}
                </template>
            </Column>
            <Column header="Профит" >
                <template #body="slotProps">
                    <div>{{round(calculateValueProfit(slotProps.data, currentPrice), 4)}}</div>
                </template>
            </Column>
            <Column>
                <template #body="slotProps">
                    <div class="flex justify-content-center align-content-center w-3rem h-2rem">
                        <div v-if="isSellDeal === slotProps.data.id">
                            <ProgressSpinner style="width:20px;height:20px" class="mt-1" strokeWidth="4" animationDuration=".9s"/>
                        </div>
                        <div v-else>
                            <Button @click="sellDeal(slotProps.data.id)" class="p-button-text p-button-danger p-button-sm">Продать</Button>
                        </div>
                    </div>
                </template>
            </Column>
            <ColumnGroup type="footer" v-if="deals.length > 0">
                <Row>
                    <Column></Column>
                    <Column></Column>
                    <Column></Column>
                    <Column></Column>
                    <Column></Column>
                    <Column :footer="averagePercent"></Column>
                    <Column :footer="sumProfit"></Column>
                    <Column>
                        <template #footer="slotProps">
                            <div class="flex justify-content-center align-content-center w-3rem h-2rem">
                                <div v-if="isSellAllDeals">
                                    <ProgressSpinner style="width:20px;height:20px" class="mt-1" strokeWidth="4" animationDuration=".9s"/>
                                </div>
                                <div v-else>
                                    <Button @click="sellAllDeals" class="p-button-text p-button-danger p-button-sm">Продать&nbsp;всё</Button>
                                </div>
                            </div>
                        </template>
                    </Column>
                </Row>
            </ColumnGroup>
        </DataTable>
    </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Row from "primevue/row";
import helperMethods from '@/helpers';
import axios from "axios";
import ProgressSpinner from "primevue/progressspinner";
import Button from "primevue/button";

export default {
    components: {
        DataTable, Column, ProgressSpinner, Button, ColumnGroup, Row
    },
    props:{
        deals: Array,
        currentPrice: String,
    },
    data(){
        return {
            isSellDeal: false,
            isSellAllDeals: false,
        }
    },
    computed: {
        averagePercent(){
            if(this.deals.length === 0){
                return 1;
            }
            let sum = 0;
            this.deals.forEach(deal => {
                sum += this.calculatePercentProfit(deal, this.currentPrice);
            });
            return this.round(sum / this.deals.length , 4);
        },
        sumProfit(){
            let sum = 0;
            this.deals.forEach(deal => {
                sum += this.calculateValueProfit(deal, this.currentPrice);
            });
            return this.round(sum, 4);
        }
    },
    methods:{
        ...helperMethods,
        sellDeal(dealId){
            this.isSellDeal = dealId;
            this.$inertia.post('/bot/sell_deal', {
                deal_id: dealId
            },{
                onSuccess: (page) => {  this.isSellDeal = false;  }
            });
        },
        sellAllDeals(){
            this.isSellAllDeals = true;
            this.$inertia.post('/bot/sell_deals', {
                deals_ids: this.deals.map((deal)=>deal.id)
            },{
                onSuccess: (page) => {  this.isSellAllDeals = false;  }
            });
        },
    }

}
</script>
